import React from "react";
import "./ServiceM.css";
// import DShieldPro from "../../Img/services/DShieldPro.png";
// import DShieldProMax from "../../Img/services/DShieldProMax.png";
import Harsafe_Meet from "../../Img/services/Harsafe_meet.svg";
import Reels from "../../Img/services/reels.svg";
import HisabBook from "../../Img/services/hisabbook.svg";
import ECommerce from "../../Img/services/ecommerce.png";
import UPIPay from "../../Img/services/UPIPay.png";
import SchoolManagement from "../../Img/services/service-icon-2.png";
import ServiceIcon6 from "../../Img/services/service-icon-6.png";
import { Link } from "react-router-dom";

const services = [
  // {
  //   icon: DShieldPro,
  //   title: "DShield Pro",
  //   description: "DShield Pro is a Complete Solution of Your EMI Safety.",
  //   link: "/DShieldPro"
  // },
  // {
  //   icon: DShieldProMax,
  //   title: "DShield Pro Max",
  //   description: "A secure mobile app that locks your phone until you make EMI payments, ensuring financial discipline and timely repayments.",
  //   link: "/DShieldProMax"
  // },
  {
    icon: Harsafe_Meet,
    title: "Harsafe Meet Chat App",
    description:
      "Our chat app enables real-time messaging, file sharing, and group conversations, enhancing communication and collaboration for personal, educational, or professional use.",
    link: "/Harsafe_Meet",
  },
  {
    icon: Reels,
    title: "Harsafe Meet Reels",
    description:
      "A creative platform for sharing short video content, allowing users to express themselves, discover trends, and engage with a global audience.",
    link: "/Reels_Main",
  },
  {
    icon: HisabBook,
    title: "Harsafe Meet Hisab Book",
    description:
      "A smart financial tracker that helps manage daily expenses, monitor budgets, and keep accurate records of income and expenditures.",
    link: "/HisabBook",
  },
  {
    icon: ECommerce,
    title: "Harsafe Meet E-Commerce",
    description:
      "A user-friendly platform for buying and selling products, offering a smooth shopping experience with secure payment gateways and quick delivery.",
    link: "#",
  },
  {
    icon: UPIPay,
    title: "Harsafe Pay",
    description:
      "A fast and secure app for seamless online transactions, enabling users to make payments, transfers, and manage their finances conveniently.",
    link: "#",
  },
  {
    icon: SchoolManagement,
    title: "School Management System",
    description:
      "A School Management System efficiently handles administrative tasks, student records, scheduling, and communication, enhancing overall school operations and productivity.",
    // link: "/SchoolMS"
    link: "#",
  },
];

const ServiceM = () => {
  return (
    <section className="section section-padding harsafe-service-section">
      <div className="container">
        <div className="section-title text-center">
          <h3 className="sub-title">Our Services</h3>
          <h2 className="title">
            We Truly Provide Services That Make Your Life Easier
          </h2>
        </div>
        <div className="row mt-5">
          {services.map((service, index) => (
            <div key={index} className="col-md-6 col-sm-12 mb-3">
              <div className="icon-box text-center hero-bg">
                <div className="service-icon">
                  <img src={service.icon} alt={service.title} />
                </div>
                <h6>
                  <Link to={service.link}>{service.title}</Link>
                </h6>
                <p>{service.description}</p>
                <Link to={service.link} className="btn-link">
                  {service.link !== "#" ? "Read More" : "Comming Soon"}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceM;
